import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  changePasswordSuccess: false,
  error: null,
};

const slice = createSlice({
  name: 'change-password',
  initialState: initialState,
  reducers: {
    changePasswordAction: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    changePasswordSuccessAction: state => {
      state.loading = true;
      state.error = null;
      state.changePasswordSuccess = true;
    },
    changePasswordErrorAction: (state, action) => {
      state.loading = false;
      state.changePasswordSuccess = false;
      state.error = action.payload;
    },
    changePasswordResetState: () => initialState,
  },
});

export const {
  changePasswordAction,
  changePasswordSuccessAction,
  changePasswordErrorAction,
  changePasswordResetState,
} = slice.actions;

export default slice.reducer;
